/**
 * @generated SignedSource<<b1a5ef9ab2cba6daaf67d2a7c2f42d2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MicrophoneRecording_completeClientSideRecordingMutation$variables = {
  audioFilePath: string;
  meetingRecordingId: string;
  pauses: ReadonlyArray<ReadonlyArray<number>>;
};
export type MicrophoneRecording_completeClientSideRecordingMutation$data = {
  readonly completeClientSideMeetingRecording: {
    readonly meetingRecording: {
      readonly id: string;
    };
  } | null;
};
export type MicrophoneRecording_completeClientSideRecordingMutation = {
  response: MicrophoneRecording_completeClientSideRecordingMutation$data;
  variables: MicrophoneRecording_completeClientSideRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audioFilePath"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pauses"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audioFilePath",
        "variableName": "audioFilePath"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      },
      {
        "kind": "Variable",
        "name": "pauses",
        "variableName": "pauses"
      }
    ],
    "concreteType": "CompleteClientSideMeetingRecording",
    "kind": "LinkedField",
    "name": "completeClientSideMeetingRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrophoneRecording_completeClientSideRecordingMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "MicrophoneRecording_completeClientSideRecordingMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "800ab4adc4701c71266481f37c3e74bd",
    "id": null,
    "metadata": {},
    "name": "MicrophoneRecording_completeClientSideRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation MicrophoneRecording_completeClientSideRecordingMutation(\n  $meetingRecordingId: ID!\n  $audioFilePath: String!\n  $pauses: [[Float!]!]!\n) {\n  completeClientSideMeetingRecording(meetingRecordingId: $meetingRecordingId, audioFilePath: $audioFilePath, pauses: $pauses) {\n    meetingRecording {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6cb4d5ba509f5ac03aee95c1c7eeea86";

export default node;
